import styled from 'styled-components';

export const Icon = styled.button`
  border: 0 none;
  background-color: transparent;
  margin: 0 24px;

  &:hover {
    opacity: 0.7;
  }
`;
